import nookies from 'nookies';
const MAX_AGE = 60 * 60;
const ACTIVE_ACCOUNT_COOKIE_NAME = 'owners-selected-account';
const getActiveAccountCookie = (ctx) => nookies.get(ctx)[ACTIVE_ACCOUNT_COOKIE_NAME];
export const evalActiveAccountCookie = (userAccounts, ctx) => {
    var _a;
    const activeAccountCookieVal = getActiveAccountCookie(ctx);
    return ((activeAccountCookieVal &&
        ((_a = userAccounts.find((account) => account.accountID === +activeAccountCookieVal)) === null || _a === void 0 ? void 0 : _a.accountID)) ||
        userAccounts[0].accountID);
};
export const setActiveAccountCookie = (accountId, domain, ctx) => nookies.set(ctx, ACTIVE_ACCOUNT_COOKIE_NAME, accountId.toString(), {
    maxAge: MAX_AGE,
    path: '/',
    domain: domain,
});
